import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getStudentClassAssignmentsService } from "@/service/dashboard.service";
import type { StudentAssignment } from "@/types/assignment.model";
import { RootState } from "../index";

interface StudentClassAssignmentsState {
  assignments: StudentAssignment[];
  loading: boolean;
  error: string | null;
  currentPage: number;
  pageSize: number;
}

const initialState: StudentClassAssignmentsState = {
  assignments: [],
  loading: false,
  error: null,
  currentPage: 1,
  pageSize: 10,
};

export const fetchStudentClassAssignments = createAsyncThunk(
  "studentClassAssignments/fetchData",
  async ({
    page = 1,
    pageSize = 10,
  }: { page?: number; pageSize?: number } = {}) => {
    const response = await getStudentClassAssignmentsService(page, pageSize);
    return response.data.data?.assignments ?? [];
  }
);

const studentClassAssignmentsSlice = createSlice({
  name: "studentClassAssignments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentClassAssignments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentClassAssignments.fulfilled, (state, action) => {
        state.loading = false;
        state.assignments = action.payload;
      })
      .addCase(fetchStudentClassAssignments.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch student class assignments";
      });
  },
});

export const selectStudentClassAssignments = (state: RootState) =>
  state.studentClassAssignments.assignments;
export const selectStudentClassAssignmentsLoading = (state: RootState) =>
  state.studentClassAssignments.loading;
export const selectStudentClassAssignmentsError = (state: RootState) =>
  state.studentClassAssignments.error;

export default studentClassAssignmentsSlice.reducer;
